type Option = {
  tag: string;
  title: string;
  lead: string;
  bullets: string[];
  price: string;
  accent: string;
  variant: "cost" | "win";
};

const options: Option[] = [
  {
    tag: "Option 1",
    title: "Do nothing",
    lead: "Stick with the spreadsheets, sticky notes, and 9pm emails.",
    bullets: [
      "~40 hrs/week of work your team is doing by hand",
      "Leads go cold while you're on a job site",
      "Competitors with better systems quote faster and win the work",
    ],
    price: "Cost: 40+ hrs/week, every week",
    accent: "var(--red)",
    variant: "cost",
  },
  {
    tag: "Option 2",
    title: "Hire whoever's on Google",
    lead: "Random consultant, generic IT shop, or a freelancer with a slide deck.",
    bullets: [
      "You become the project manager on top of running the business",
      "They learn on your dime — usually with no track record to check",
      "Six months later you've got a half-built tool nobody uses",
    ],
    price: "Cost: $50k–$150k and a year you can't get back",
    accent: "var(--orange)",
    variant: "cost",
  },
  {
    tag: "Option 3",
    title: "Hire Tiny Cloud",
    lead: "Specialists who learn your business, ship the system, and stick around.",
    bullets: [
      "First system live in weeks, not quarters",
      "Fixed scope, fixed price — written down before we start",
      "Same team that built it answers when you call",
    ],
    price: "Cost: fixed scope. Weeks, not quarters.",
    accent: "var(--yellow)",
    variant: "win",
  },
];

export function Cost() {
  return (
    <section className="section cost" id="cost">
      <div className="container">
        <div className="cost-head">
          <span className="eyebrow">The math</span>
          <h2 className="section-title">What it costs to wait.</h2>
          <p className="section-sub">
            You don&rsquo;t have to hire us. But the alternatives have a price
            tag too &mdash; usually a bigger one.
          </p>
        </div>

        <div className="cost-grid">
          {options.map((o) => (
            <article
              key={o.title}
              className={`cost-card is-${o.variant}`}
              style={{ ["--accent" as never]: o.accent }}
            >
              <span className="cost-tag">{o.tag}</span>
              <h3 className="cost-title">{o.title}</h3>
              <p className="cost-lead">{o.lead}</p>
              <ul className="cost-list">
                {o.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
              <div className="cost-foot">
                <span className="cost-price">{o.price}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
